<div class="main-relative">
    <!-- <img *ngIf="index === 0" class="city-colours__img1" [lazyLoad]="colorIMG"> -->
    <div class="left-main" [attr.data-position]="position" *ngIf="position == 'left'">
        <div class="about-city">
            <div class="about-city__image" [defaultImage]="item?.imageMicro" [lazyLoad]="item?.image">
            </div>
            <div class="about-city__container">
                <p class="about-city__container-title">{{item?.title}}</p>
                <span class="about-city__container-info" [innerHTML]="item?.text"></span>
            </div>
        </div>
    </div>
    <!-- <img *ngIf="index === 0" class="city-colours__img2" [lazyLoad]="colorIMG"> -->
    <div class="right-main" [attr.data-position]="position" *ngIf="position == 'right'">
        <div class="right-position">
            <div class="right-position__container">
                <p class="right-position__container-title">{{item?.title}}</p>
                <span class="right-position__container-info" [innerHTML]="item?.text"></span>
            </div>
            <div class="right-position__image" [defaultImage]="item?.imageMicro" [lazyLoad]="item?.image">
            </div>
        </div>
    </div>
</div>